import  { useEffect, useState } from 'react'
import Editor, { Toolbar } from 'react-simple-wysiwyg'

const LabsFreeType = ({
  patientDBdata,
  patientID,
  setPatientDBdata,
  noteActualId,
}) => {
  const [labIds, setLabIds] = useState([])
  const [labs, setLabs] = useState([])
  const [tempLabHtml, setTempLabHtml] = useState('')
  const [originalLabHtml, setOriginalLabHtml] = useState('')

  useEffect(() => {
    const metadataId =
      patientDBdata?.currentNote?.data?.metadata?.labId || []
        console.log(metadataId, 'metadataId for labs')


    const ids = Array.isArray(metadataId)
      ? metadataId
      : metadataId
      ? [metadataId]
      : []

    setLabIds(ids)
  }, [patientDBdata, patientID])

  useEffect(() => {
    if (!labIds.length) {
      setLabs([])
      return
    }

    const matchedLabs =
      patientDBdata?.patientLabData?.filter((item) =>
        labIds.includes(item.id)
      ) || []

    setLabs(matchedLabs)
  }, [labIds, patientDBdata])

  useEffect(() => {
  if (!Array.isArray(labs) || !labs.length) return

  const generatedHtml = `
    <div>
      ${labs
        .map(
          (lab) => `
        <div style="margin-bottom:16px;">
          <div><strong>Date:</strong> ${lab.date || '-'}</div>
          <div style="margin-top:12px;">
            ${lab.data
              ?.map(
                (item) => `
              <div>
                <div style="min-width:120px;">
                  ${item.name} ${item.value ?? ''} ${item.unit ?? ''}
                </div>
              </div>
            `
              )
              .join('')}
          </div>
        </div>
      `
        )
        .join('')}
    </div>
  `

  const savedFreeType =
    patientDBdata?.currentNote?.data?.freeTypesEverything?.labsFreetype

  const initialHtml = savedFreeType || generatedHtml

  setOriginalLabHtml(generatedHtml)
  setTempLabHtml(initialHtml)

  if (!savedFreeType) {
    setPatientDBdata((prev) => ({
      ...prev,
      currentNote: {
        ...prev.currentNote,
        data: {
          ...prev.currentNote.data,
          freeTypesEverything: {
            ...prev.currentNote.data?.freeTypesEverything,
            labsFreetype: initialHtml,
          },
        },
      },
    }))
  }
}, [labs])


  useEffect(() => {
    if (!Array.isArray(labs) || !labs.length) return

    const html = `
      <div>
        ${labs
          .map(
            (lab) => `
          <div style="margin-bottom:16px;">
            <div><strong>Date:</strong> ${lab.date || '-'}</div>
            <div style="margin-top:12px;">
              ${lab.data
                ?.map(
                  (item) => `
                <div style=";">
                  <div style="min-width:120px;">${item.name} ${item.value ?? ''} ${item.unit ?? ''}</div>
                </div>
              `
                )
                .join('')}
            </div>
          </div>
        `
          )
          .join('')}
      </div>
    `

    const savedFreeType =
      patientDBdata?.currentNote?.data?.freeTypesEverything?.labsFreetype

    setOriginalLabHtml(html)
    setTempLabHtml(savedFreeType || html)
  }, [labs, patientDBdata])

  const handleBlur = () => {
    setPatientDBdata((prev) => ({
      ...prev,
      currentNote: {
        ...prev.currentNote,
        data: {
          ...prev.currentNote.data,
          freeTypesEverything: {
            ...prev.currentNote.data?.freeTypesEverything,
            labsFreetype: tempLabHtml,
          },
        },
      },

      allNotes: prev.allNotes?.map((note) => {
        if (note.id !== noteActualId) return note

        const parsedData = note.data ? JSON.parse(note.data) : {}

        return {
          ...note,
          data: JSON.stringify({
            ...parsedData,
            freeTypesEverything: {
              ...parsedData.freeTypesEverything,
              labsFreetype: tempLabHtml,
            },
          }),
        }
      }),
    }))
  }

  if(!labIds.length) return null

  return (
    <div className="d-flex">
      <div style={{ width: '30%' }}>Labs</div>

      <div className="w-100">
        <Editor
          value={tempLabHtml}
          onChange={(e) => setTempLabHtml(e.target.value)}
          onBlur={handleBlur}
          containerProps={{
            style: {
              width: '100%',
              background: '#2D2D2D',
              color: 'white',
              border: 0,
            },
          }}
        >
          <Toolbar hidden />
        </Editor>
      </div>
    </div>
  )
}

export default LabsFreeType
